import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/charging.svg'
import _imports_1 from '@/assets/img/occupied.svg'
import _imports_2 from '@/assets/img/iceing.svg'
import _imports_3 from '@/assets/img/hogging.svg'


const _withScopeId = n => (_pushScopeId("data-v-d539e340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-8 bg-white px-6 pt-12 pb-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-semibold mb-6" }, "System Overview", -1))
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 pb-12" }
const _hoisted_5 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_6 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "location"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "Station"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "Bay"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "Duration"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "table-head"
    }, "Event type")
  ])
], -1))
const _hoisted_9 = {
  key: 0,
  class: "bg-white divide-y divide-gray-200"
}
const _hoisted_10 = { class: "table-data text-gray-500" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[127px] h-42 rounded-sm bg-gray-200 mb-5 animate-pulse2" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "bg-white divide-y divide-gray-200"
}
const _hoisted_14 = { class: "table-data text-gray-500" }
const _hoisted_15 = { class: "table-data text-gray-900" }
const _hoisted_16 = { class: "table-data text-gray-500" }
const _hoisted_17 = { class: "table-data text-gray-500" }
const _hoisted_18 = { class: "table-data text-gray-500" }
const _hoisted_19 = { class: "table-data" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "w-4"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "w-4"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "w-4"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "w-4"
}
const _hoisted_27 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "w-4"
}
const _hoisted_28 = {
  key: 2,
  src: _imports_3,
  alt: "",
  class: "w-4"
}
const _hoisted_29 = { class: "ml-4" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "p-8" }

import { Analytics } from '@/types/interface';
import { secondsToHmSs, formatDate } from '@/utils/dateTimeFormat';
import Pagination from '@/components/shared/Pagination.vue';

interface Props {
  analytics: Analytics[];
  selectedLocation: {
    name: string;
    id: string;
  };
  totalProducts: number;
  pageCount: number;
  currentPageEnd: number;
  currentPageStart: number;
  isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    analytics: null,
    selectedLocation: null,
    totalProducts: null,
    pageCount: null,
    currentPageEnd: null,
    currentPageStart: null,
    isLoading: { type: Boolean }
  },
  emits: ["handlePaginate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'handlePaginate', num: number): void;
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_) => {
                      return _createElementVNode("tr", null, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_) => {
                          return _createElementVNode("td", _hoisted_10, _hoisted_12)
                        }), 64))
                      ])
                    }), 64))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.analytics, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatDate)(item.occupiedStart)), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(__props.selectedLocation.name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.stationId), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(item.bayId), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(secondsToHmSs)(item.duration)), 1),
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["px-6 py-3 inline-flex items-center justify-center leading-5 font-semibold rounded-full", [
                        {
                          'tl-occupied':
                            !item.charging &&
                            !item.bayHoggingIncident &&
                            !item.icingIncident,
                        },
                        {
                          'tl-charging': item.charging,
                        },
                        { 'tl-iceing': item.icingIncident },
                        {
                          'tl-hogging':
                            item.bayHoggingIncident && !item.icingIncident,
                        },
                      ]])
                          }, [
                            (!item.occupiedEnd)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  (item.charging)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_22))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (
                            !item.charging &&
                            !item.icingIncident &&
                            !item.bayHoggingIncident
                          )
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        (item.charging)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                                          : (item.icingIncident)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                                            : (item.bayHoggingIncident)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                                              : _createCommentVNode("", true)
                                      ]))
                                ])),
                            _createElementVNode("span", _hoisted_29, [
                              (!item.occupiedEnd)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                    (item.charging)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Charging"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_32, "Occupied"))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                    (
                              !item.icingIncident &&
                              !item.bayHoggingIncident &&
                              !item.charging
                            )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Occupied"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                          (item.charging)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Charging "))
                                            : (item.icingIncident)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Iceing "))
                                              : (item.bayHoggingIncident)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Bay Hogging "))
                                                : _createCommentVNode("", true)
                                        ]))
                                  ]))
                            ])
                          ], 2)
                        ])
                      ]))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(Pagination, {
                pageCount: __props.pageCount,
                onHandlePaginate: _cache[0] || (_cache[0] = ($event: any) => (emit('handlePaginate', $event)))
              }, null, 8, ["pageCount"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})